// extracted by css-extract-rspack-plugin
module.exports =  {"tag":"Tag__tag--E0BRW"};